<template>
  <div class="flex items-center gap-2 w-full justify-start">

    <div class="flex items-center gap-2 overflow-hidden">
      <span class="truncate font-semibold text-gray-700">{{ displayName }}</span>

      <div v-if="headerTooltip" v-tooltip="headerTooltip" class="cursor-help text-slate-400 hover:text-slate-600 transition-colors">
        <BxInfoCircle class="w-4 h-4" />
      </div>
    </div>

    <!-- Remove All Tags Action -->
    <div v-if="isTag" class="flex-shrink-0">
      <button v-tooltip="t('tooltip-remove-all-tags', { name: deleteTagName })" @click.stop="showModal = true" class="p-1 rounded-md hover:bg-red-50 text-slate-400 hover:text-red-500 transition-colors">
        <MaterialSymbolsDeleteOutline class="w-4 h-4" />
      </button>
    </div>
  </div>

  <CommonConfirmationModal v-model="showModal" :title="t('mapping.remove-all-tags.title')" :heading="t('modal-warning-title')" :description="t('confirm-remove-all-tags', { name: deleteTagName })"
    :confirmButtonText="t('modal-delete-button')" @onConfirm="confirmChange" :onClose="cancelChange" :loading-btn="btnLoading" />
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import MaterialSymbolsDeleteOutline from "~/assets/svgs/MaterialSymbolsDeleteOutline.vue";
import { BxRegularInfoCircle as BxInfoCircle } from "vue-icons-lib/bx";
import { useAcmStore } from "~/stores/acm.store";
import {StcsFstmtEnum} from "~/protos/gen/stcs_enums.entity.ts";
import CommonConfirmationModal from "~/components/common/ConfirmationModal.vue";

import { useTranslate } from '~/composables/useTranslate';
const { t } = useTranslate();

const acmStore = useAcmStore();

const showModal = ref(false);
const btnLoading = ref(false);

const props = defineProps({
  params: { type: Object, required: true },
});

const { displayName, headerTooltip, column } = props?.params;

const deleteTagName = computed(() =>
  acmStore.activeFinancialStatement === StcsFstmtEnum.SFSE_PNL
    ? t('general-terms-pnl')
    : t('general-terms-bs')
);

const isTag = column.colId === "tags";

const confirmChange = () => {
  btnLoading.value = true;
  setTimeout(async () => {
    await acmStore.deleteALlTags(() => { }, () => { });
    btnLoading.value = false;
    showModal.value = false;
  }, 500);
};

const cancelChange = () => {
  showModal.value = false;
  btnLoading.value = false;
};
</script>
